import { resolved } from 'store/createAction';
import { GET_NOTE } from './types';

const initialState = {
  data: {},
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case resolved(GET_NOTE):
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.hash]: action.payload,
        },
      };
    default:
      return state;
  }
}
